<template>
  <div>

    <div class="field is-horizontal">
      <div class="field-body">
        <div class="field">
          <h3 class="title is-3">Import a map in KML format</h3>
        </div>
      </div>
    </div>

    <form>
      <b-field horizontal label="Name:"
               :type="{ 'is-danger': errorName }"
               :message="{ 'Name cannot be blank': errorName }">
        <b-input
            v-model="name"
            placeholder="Name (e.g. 'Sydney CBD')"
            :has-counter="false"
        >
        </b-input>
      </b-field>

      <b-field horizontal label="Description:"
               :type="{ 'is-danger': errorDescription }"
               :message="{ 'Description cannot be blank': errorDescription }">
        <b-input
            v-model="description"
            placeholder="Description (e.g. '12 challenges in the CBD, 4km all together')"
            :has-counter="false"
        >
        </b-input>
      </b-field>

      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">KML file</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input type="file" class="input" @change="onFileChange">
            </div>
          </div>
        </div>
      </div>
      <div v-if="isFileLoaded">
        <div>
          <b-table
              :data="geolocationPoints"
              :loading="!isFileLoaded"
              :striped="true"
              :hoverable="true">
            <template slot-scope="props">
              <b-table-column class="centered-table-content" field="name" label="Name" sortable>
                {{ props.row.name }}
              </b-table-column>

              <b-table-column class="centered-table-content" field="lng" label="Longitude">
                {{ props.row.lat }}
              </b-table-column>

              <b-table-column class="centered-table-content" field="lat" label="Latitude">
                {{ props.row.lng }}
              </b-table-column>
            </template>
          </b-table>
        </div>
        <div class="map-previewer">
          <map-previewer :markers="markers" :center="center" ref="map_previewer" :mapType='mapType'
                         :height="600" v-if="isFileLoaded">
          </map-previewer>
        </div>
      </div>
      <div class="control submit">
        <button class="button is-light btn-margin" @click.prevent="cancel()">Back to maps</button>
        <button @click.prevent="importMap" class="button is-primary btn-margin">Import the map</button>
      </div>
    </form>

  </div>
</template>

<script>
import MapPreviewer from './single/MapPreviewer'
import displayHelper from '../helpers/display-helper'
import mapService from '../services/mapService'

var Parser = require('xml2js').Parser

export default {
  name: 'MapImport',
  data() {
    return {
      maps: [],
      name: '',
      description: '',
      geolocationPoints: [],
      mapType: 'terrain',

      isFileLoaded: false,
      markers: [],
      center: {lat: 1.3581036, lng: 103.8329625},

      errorName: false,
      errorDescription: false
    }
  },
  components: {
    MapPreviewer
  },
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.parseKML(files[0])
    },
    parseKML(file) {
      console.log('parsing KML file...')
      var reader = new FileReader()

      reader.onload = (e) => {
        this.geolocationPoints = this.transformKMLToGeolocPoints(e.target.result)
      }
      reader.readAsText(file)
    },
    transformKMLToGeolocPoints(xml) {
      var parser = new Parser()
      var tabGeoloc = []

      var parent = this
      var localMarkers = []

      parser.parseString(xml, function (err, result) {
        if (err) {
          displayHelper.displayError(parent, 'Unable to import the file. Check that this is a KML-formatted file.')
          parent.isFileLoaded = false

        } else {
          const placeMarks = result.kml.Document[0].Placemark

          placeMarks.forEach((p) => {
            var coords = p.Point[0].coordinates[0].trim()
            var name = p.name[0]

            const virg = coords.indexOf(',', 0)
            var lng = coords.substring(0, virg)
            var lat = coords.substring(virg + 1, coords.length - 2)

            tabGeoloc.push({name, lng, lat})
            localMarkers.push({title: name, position: {lng: Number(lng), lat: Number(lat)}})
          })

          parent.markers = localMarkers
          parent.isFileLoaded = true

          displayHelper.displaySuccess(parent, 'File has been imported successfully.')
        }
      })
      return tabGeoloc
    },
    importMap() {
      if (!this.validateFields()) {
        console.log('Errors in fields')
        return
      }

      this.isLoading = true
      var parent = this

      const map = {
        name: this.name,
        description: this.description,
        geolocationPoints: this.geolocationPoints
      }

      mapService.createMap(map)
          .then(() => {
            displayHelper.displaySuccess(parent, 'Map successfully imported')
            this.$router.back()
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Error while adding the map: ' + err.message)
          })
    },
    validateFields() {
      let hasErrors = false
      if (!this.name) {
        this.errorName = true
        hasErrors = true
      }
      if (!this.description) {
        this.errorDescription = true
        hasErrors = true
      }
      return !hasErrors
    }
  }
}
</script>

<style scoped>
.btn-margin {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px;
}

.field-label {
  flex-grow: 1;
}

.map-previewer {
  margin-top: 20px;
}
</style>
